const BASE_FEATURE_MAPPING = {
  AWD: {
    text: "AWD/4WD",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "driveTrainShort",
      expectedValue: ["AWD", "4x4"],
    },
  },
  FWD: {
    text: "FWD",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "driveTrainShort",
      expectedValue: ["FWD"],
    },
  },
  leather: {
    text: "Leather",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.seatsType",
      expectedValue: ["leather"],
    },
  },
  cloth: {
    text: "Cloth",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.seatsType",
      expectedValue: ["cloth"],
    },
  },
  aerialViewCamera: {
    text: "360 Camera",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.aerialViewCamera",
      expectedValue: [true],
    },
  },
  rearCamera: {
    text: "Backup Camera",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.rearCamera",
      expectedValue: [true],
    },
  },
  sunroof: {
    text: "Sunroof",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.firstRowSunroof",
      expectedValue: [true],
    },
  },
  noSunroof: {
    text: "No Sunroof",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.firstRowSunroof",
      expectedValue: [true],
    },
  },
  premiumSoundSystem: {
    text: "Premium Sound System",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.premiumSoundSystem",
      expectedValue: [true],
    },
  },
  regularSoundSystem: {
    text: "Regular Sound System",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.premiumSoundSystem",
      expectedValue: [false],
    },
  },
  heatedSeats: {
    text: "Heated Seats",
    subtext: "",
    greyicon: "feature-heated-seats-grey.svg",
    selected: false,
    dbMapping: {
      path: "maeFeatures.heatedSeats",
      expectedValue: [true],
    },
  },
  heatedSteeringWheel: {
    text: "Heated Steering Wheel",
    subtext: "",
    greyicon: "feature-heated-steering-wheel-grey.svg",
    selected: false,
    dbMapping: {
      path: "maeFeatures.heatedSteeringWheel",
      expectedValue: [true],
    },
  },
  keylessEntryAndPushStart: {
    text: "Keyless Entry & Push Start",
    subtext: "",
    greyicon: "feature-push-start-grey.svg",
    selected: false,
    dbMapping: {
      path: "maeFeatures.keylessEntryAndPushStart",
      expectedValue: [true],
    },
  },
  seatMemory: {
    text: "Memory Seat",
    subtext: "",
    greyicon: "feature-seat-memory-grey.svg",
    selected: false,
    dbMapping: {
      path: "maeFeatures.seatMemory",
      expectedValue: [true],
    },
  },
  powerSeats: {
    text: "Power Seats",
    subtext: "",
    greyicon: "feature-power-seats-grey.svg",
    selected: false,
    dbMapping: {
      path: "maeFeatures.powerSeats",
      expectedValue: [true],
    },
  },
  appleCarPlayAndroidAuto: {
    text: "Apple CarPlay/Android Auto",
    subtext: "",
    greyicon: "feature-carplay-grey.svg",
    selected: false,
    dbMapping: {
      path: "maeFeatures.appleCarPlayAndroidAuto",
      expectedValue: [true],
    },
  },
  powerLiftgate: {
    text: "Power Liftgate",
    subtext: "",
    greyicon: "feature-power-liftgate-grey.svg",
    selected: false,
    dbMapping: {
      path: "maeFeatures.powerLiftgate",
      expectedValue: [true],
    },
  },
  fiveSeats: {
    supportedText: "Seats: ",
    text: "5",
    subtext: "",
    greyicon: "",
    selected: true,
    dbMapping: {
      path: "maeFeatures.seatingCapacity",
      expectedValue: [5],
    },
  },
  sixSeats: {
    supportedText: "Seats: ",
    text: "6",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.seatingCapacity",
      expectedValue: [6],
    },
  },
  sevenSeats: {
    supportedText: "Seats: ",
    text: "7",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.seatingCapacity",
      expectedValue: [7],
    },
  },
  eightSeats: {
    supportedText: "Seats: ",
    text: "8",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures.seatingCapacity",
      expectedValue: [8],
    },
  },
  blackColor: {
    supportedText: "Color: ",
    text: "⚫ Black",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  whiteColor: {
    supportedText: "Color: ",
    text: "⚪ White",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  greyColor: {
    supportedText: "Color: ",
    text: "🔘 Grey",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  blueColor: {
    supportedText: "Color: ",
    text: "🔵 Blue",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  redColor: {
    supportedText: "Color: ",
    text: "🔴 Red",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  greenColor: {
    supportedText: "Color: ",
    text: "🟢 Green",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  orangeColor: {
    supportedText: "Color: ",
    text: "🟠 Orange",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  brownAndGoldColor: {
    supportedText: "Color: ",
    text: "🟤 Brown/Gold",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
  otherColor: {
    supportedText: "Color: ",
    text: "Other",
    subtext: "",
    greyicon: "",
    selected: false,
    dbMapping: {
      path: "maeFeatures",
      expectedValue: [8],
    },
  },
};

//to ensure the featurekey is always the same
export const FEATURE_MAPPING = Object.fromEntries(
  Object.entries(BASE_FEATURE_MAPPING).map(([featureKey, value]) => [
    featureKey,
    { ...value, featureKey },
  ])
);
